import { Component, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MoneyForBuckService } from 'src/app/service/money-for-buck-service/money-for-buck.service';
import * as moment from 'moment';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';

@Component({
  selector: 'app-mfb',
  templateUrl: './mfb.component.html',
  styleUrls: ['./mfb.component.css']
})
export class MfbComponent implements OnInit {
  user;
  search;
  selectedDriver = [];
  predriverList = {};
  drivers = [];
  driverExpenses;
  driverVehicleExpenses;
  timeZone;
  mfbForm: UntypedFormGroup;
  bucksList = [];
  filteredBucksList = [];
  submitted = false;
  status = 'active';

  constructor(
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private mfbService: MoneyForBuckService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.getUser();
    this.getBucks();
  }

  get form() {
    return this.mfbForm.controls;
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.getDriverList();
        }
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, '')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          const buckDriverIds = this.bucksList.map(buck => buck.driver);
          this.predriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.drivers = data.filter(driver => buckDriverIds.includes(driver._id));
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getBucks() {
    this.mfbService
      .getBucks()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.bucksList = data;
          this.filterBucksByDriver();
          this.getDriverList();
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  filterBucksByDriver() {
    if (this.selectedDriver.length === 0) {
      this.filteredBucksList = this.bucksList;
    } else {
      this.filteredBucksList = this.bucksList.filter(buck =>
        this.selectedDriver.includes(buck.driver)
      );
    }
  }

  filterTripsByModel() {
    this.filterBucksByDriver();
  }

  ngOnDestroy(): void {
  }
}
